<template>
  <main>
    <div class="container pt-4 pb-5">
      <section class=" col-md-12 ">
        <h4 class="pb-4">VIP INFO</h4>
        <form>
          <div class="row form-group ">
            <div class="col-md-12 mb-3 row content_padding">
              <label class="col-md-1" style="line-height: 3rem;text-align: right;padding-right: 1rem;">Country:</label>
              <input type="text" class="form-control col-md-11"
                style="background-color: transparent;border: 1px solid gray;">
            </div>

            <div class="col-md-12 mb-3 row content_padding">
              <label class="col-md-1" style="line-height: 3rem;text-align: right;padding-right: 1rem;">Company:</label>
              <input type="text" class="form-control col-md-11"
                style="background-color: transparent;border: 1px solid gray;">
            </div>
            <div class="col-md-12 mb-3 row content_padding">
              <label class="col-md-1" style="line-height: 3rem;text-align: right;padding-right: 1rem;">Name:</label>
              <input type="text" class="form-control col-md-11"
                style="background-color: transparent;border: 1px solid gray;">
            </div>
            <div class="col-md-12 mb-3 row content_padding">
              <label class="col-md-1" style="line-height: 3rem;text-align: right;padding-right: 1rem;">E-Mail:</label>
              <input type="text" class="form-control col-md-11"
                style="background-color: transparent;border: 1px solid gray;">
            </div>
          </div>

          <button type="submit" class="btn custom-btn-primary mt-4"
            style="color: #fff;border-radius: 5px;padding: 0.5rem 3rem;">Register</button>
        </form>

      </section>
      <section class="col-md-12 text-left content_padding">
        <div class="mt-5 mb-4">
          <h5 class="mb-3"> VIP Rules </h5>
          <p>
            1. The system will automatically send email to the registered mail after registration is successful;<br>
            2. There will be 3 levels after registered successfully. China IP – Ordinary VIP. Overseas IP – Intermediate
            VIP.
            Cooperated customers – Senior VIP (Please contact the administrator for audit to be the Senior VIP).<br>
            3. You will be able to view the VIP information after registration successful.<br>
            4. The default secrecy for the new product in the VIP center will be 6 months. Over the period of time,
            will be displayed in the normal product zone;<br>
            5. Please continue to focus on Sanmak, we will launch more than 2 new products each month;<br>
            6. To ensure our customers interests, OEM or ODM products will not be displayed on our website;<br>
            7. Overseas IP could be accessed directly. But it will be banned to access if the background judged the
            overseas IP as AD,
            competition or malice.<br>
            8. China IP will not be able to browse the latest products and download data directly, will be authorized to
            access your information.<br>
          </p>
        </div>
        <div class="mt-5 mb-4">
          <h5 class="mb-3">Why to be a VIP of Sanmak?</h5>
          <p>
            1. Sanmak is a well-known enterprise in China in the vehicle application of LED lighting.<br>
            2. Sanmak has a strong R&D ability.<br>
            3. Sanmak based on providing customers with a variety of solutions;<br>
            4. After successful registration, you can continue to acquire new technologies, new processes,
            and the most complete product information.<br>
          </p>
        </div>
        <div class="mt-5">
          <h5 class="mb-3">Sanmak’s Business Philosophy:</h5>
          <p>
            1. Sanmak uphold customer – oriented. Customer is the only reason we exist. Regard customer service as our
            corporate mission.<br>
            2. Sanmak adhere product – oriented. Prove with good product and make good product with craftsman’s
            spirit.<br>
            3. Sanmak based demand – oriented. Focus on customer demands, grasp the timeliness,
            and provide the satisfactory reply to customer timely.<br>
            4. Sanmak promise quality – oriented. Insist on process improvement, ensure 100% qualified outbound,
            and exceed customer requirement.<br>
          </p>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
export default {
  name: 'JoinVIP',
  data() {
    return {
    };
  },
  methods: {

  },
};
</script>

<style scoped>
@import '../../assets/css/main.css';
</style>
